import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const STORAGE_KEY = "fcf_selected_filiera_id";
const FilieraContext = createContext(null);

export function FilieraProvider({ children }) {
  const { user } = useAuth();
  const [filiere, setFiliere] = useState([]);
  const [selectedFilieraId, setSelectedFilieraIdState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || ""
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadFiliere = async () => {
    if (!user) {
      setFiliere([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError("");
    try {
      const { data } = await api.get("/filiere");
      const nextFiliere = Array.isArray(data) ? data : [];
      setFiliere(nextFiliere);

      if (selectedFilieraId && !nextFiliere.some((f) => f.id === selectedFilieraId)) {
        localStorage.removeItem(STORAGE_KEY);
        setSelectedFilieraIdState("");
      }
    } catch (e) {
      setFiliere([]);
      setError(e.response?.data?.detail || e.message || "Impossibile caricare le filiere");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFiliere();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const setSelectedFilieraId = (filieraId) => {
    const nextId = filieraId || "";
    setSelectedFilieraIdState(nextId);
    if (nextId) localStorage.setItem(STORAGE_KEY, nextId);
    else localStorage.removeItem(STORAGE_KEY);
  };

  const selectedFiliera = useMemo(
    () => filiere.find((f) => f.id === selectedFilieraId) || null,
    [filiere, selectedFilieraId]
  );

  return (
    <FilieraContext.Provider value={{
      filiere,
      selectedFilieraId,
      selectedFiliera,
      setSelectedFilieraId,
      loading,
      error,
      refreshFiliere: loadFiliere,
    }}>
      {children}
    </FilieraContext.Provider>
  );
}

export function useFiliera() {
  const context = useContext(FilieraContext);
  if (!context) throw new Error("useFiliera deve essere usato dentro FilieraProvider");
  return context;
}
